<template>
  <div class="p-4 text-center">
    <p>Signing you in…</p>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const auth = useAuthStore();

// Module-level guard: ensure the redirect callback is only processed once,
// even if the component mounts twice (HMR, StrictMode-style double mount).
let handled = false;

onMounted(async () => {
  if (handled) return;
  handled = true;

  try {
    // Complete the login and get the original URL back
    const returnUrl = await auth.completeLogin();
    // Jump back into the SPA
    router.replace(returnUrl || "/");
  } catch (err) {
    // Couldn't complete login and no existing session — start over cleanly.
    console.error("[Callback] Login could not be completed:", err);
    router.replace("/");
  }
});
</script>
